import React from 'react';
import s from '../../s.module.less';

const SvgSearch = () => (
    <svg
        viewBox="0 0 24 24"
        width="15"
        height="15"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <circle cx="11" cy="11" r="7" />
        <line x1="21" y1="21" x2="16.65" y2="16.65" />
    </svg>
);

const initials = (name: string) =>
    name
        .split(' ')
        .map((w) => w[0])
        .join('')
        .slice(0, 2)
        .toUpperCase();

interface ProviderInfo {
    providerId: number;
    name: string;
    credentials: string;
    owner: boolean;
}

interface Props {
    providers: ProviderInfo[];
    groupSelectedProviderId: number | null;
    provDropdownOpen: boolean;
    provDropdownSearch: string;
    dropdownFilteredProviders: ProviderInfo[];
    provDropdownRef: React.RefObject<HTMLDivElement>;
    onSelectProvider: (id: number | null) => void;
    onToggleDropdown: () => void;
    onDropdownSearchChange: (val: string) => void;
}

const ProviderBar = ({
    providers,
    groupSelectedProviderId,
    provDropdownOpen,
    provDropdownSearch,
    dropdownFilteredProviders,
    provDropdownRef,
    onSelectProvider,
    onToggleDropdown,
    onDropdownSearchChange,
}: Props) => {
    const sp = providers.find((p) => p.providerId === groupSelectedProviderId) || providers[0];
    const spName = sp?.name || '';

    return (
        <div className={s.providerBar}>
            <div className={s.providerSummary}>Showing {spName}&apos;s panels across payers</div>
            {providers.length > 6 ? (
                <div className={s.provSel} ref={provDropdownRef}>
                    <div className={s.provSelTrigger} onClick={onToggleDropdown}>
                        <span className={s.provSelAvatar}>{initials(spName)}</span>
                        <div className={s.provSelCur}>
                            <span className={s.provSelCurName}>{spName}</span>
                            <span className={s.provSelCurSub}>
                                {sp?.credentials}
                            </span>
                        </div>
                    </div>
                    {provDropdownOpen && (
                        <div className={s.provSelMenu}>
                            <div className={s.provSelSearch}>
                                <SvgSearch />
                                <input
                                    placeholder={`Search ${providers.length} providers`}
                                    value={provDropdownSearch}
                                    onChange={(e) => onDropdownSearchChange(e.target.value)}
                                />
                            </div>
                            <div className={s.provSelList}>
                                <div
                                    className={`${s.provSelItem}${groupSelectedProviderId == null ? ` ${s.active}` : ''}`}
                                    onClick={() => onSelectProvider(null)}
                                >
                                    <span className={s.provSelAvatar}>&#8727;</span>
                                    <div className={s.provSelItemTxt}>
                                        <span className={s.provSelItemName}>All providers</span>
                                        <span className={s.provSelItemSub}>
                                            {providers.length} providers
                                        </span>
                                    </div>
                                </div>
                                {dropdownFilteredProviders.map((prov) => (
                                    <div
                                        key={prov.providerId}
                                        className={`${s.provSelItem}${groupSelectedProviderId === prov.providerId ? ` ${s.active}` : ''}`}
                                        onClick={() => onSelectProvider(prov.providerId)}
                                    >
                                        <span className={s.provSelAvatar}>{initials(prov.name)}</span>
                                        <div className={s.provSelItemTxt}>
                                            <span className={s.provSelItemName}>{prov.name}</span>
                                            <span className={s.provSelItemSub}>
                                                {prov.credentials}
                                            </span>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            ) : (
                <div className={s.providerChips}>
                    <span
                        className={`${s.providerChip}${groupSelectedProviderId == null ? ` ${s.active}` : ''}`}
                        onClick={() => onSelectProvider(null)}
                    >
                        All providers
                    </span>
                    {providers.map((prov) => (
                        <span
                            key={prov.providerId}
                            className={`${s.providerChip}${groupSelectedProviderId === prov.providerId ? ` ${s.active}` : ''}`}
                            onClick={() => onSelectProvider(prov.providerId)}
                        >
                            {prov.name}
                        </span>
                    ))}
                </div>
            )}
        </div>
    );
};

export default ProviderBar;
